import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue, getListFromValues } from '../../public/utility'
import { getListItems, nullDate } from '../../public/utility'
import StandardInspectionDiv from './StandardInspectionDiv'
import StandardGuidelineDiv from './StandardGuidelineDiv'
class JudgeStandardApplyDetail extends React.Component {
	state = {
		applyType: this.props.applyType || '',
		id: this.props.id,
		processing: 0,//限制并发操作
		onlyView: this.props.onlyView || false,
	}

	componentDidMount = () => {
		this.GetJudgeStandardApply()
	}

	GetJudgeStandardApply = () => {
		const { id, applyType } = this.state
		Tyan.doPostEvent({
			event: 'GetJudgeStandardApply',
			data: { id, applyType },
			onRequest: this.handelBegin,
			onEnd: ({ errorMessage, applyType, JudgeStandardID, initValues基本信息, optionsParas, initValues项目信息, initValues指标信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ id, applyType, JudgeStandardID, initValues基本信息, changedValues基本信息: {}, optionsParas, initValues项目信息, initValues指标信息 })
				}
				setTimeout(this.handelFinish, 100)
			}
		})
	}
	handelBegin = () => this.setState((state) => ({ processing: state.processing + 1 }))
	handelFinish = () => this.setState((state) => ({ processing: state.processing - 1 }))

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	handlerSave = () => {
		const { id, changedValues基本信息, applyType } = this.state

		Tyan.doPostEvent({
			event: 'SaveJudgeStandardApply',
			data: { id, applyType, changedValues基本信息, },
			onRequest: this.handelBegin,
			onEnd: ({ errorMessage, id }) => {
				setTimeout(this.handelFinish, 100)
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					this.setState({ id })
					this.GetJudgeStandardApply()
				}
			}
		})
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onSave, onClose } = this.props

		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteJudgeStandardApply',
				data: { id },
				onRequest: this.handelBegin,
				onEnd: ({ errorMessage }) => {
					setTimeout(this.handelFinish, 100)
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			}))
	}

	handlerSelectJudgeStandard = (v) => {
		Tyan.doPostEvent({
			event: 'GetJudgeStandardInfo',
			data: { 判定标准: v },
			onEnd: ({ errorMessage, objJudgeStandard, StandardItemID }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					if (objJudgeStandard) {
						Tyan.utility.changeItemsValue(this, '基本信息',
							['标准名称', '英文标准名称', '繁体标准名称', '已有牌价', '牌价'],
							[objJudgeStandard['StandardName'], objJudgeStandard['StandardNameE'], objJudgeStandard['TraditionStandardName'], objJudgeStandard['Quoteprice'], objJudgeStandard['Quoteprice']]
						)
					}
					if (StandardItemID) {
						Tyan.utility.changeItemsValue(this, '基本信息',
							['StandardItemID'],
							[StandardItemID]
						)
					}
				}
			}
		})
	}

	handleGetStandardInspectionList = () => {
		const { id } = this.state
		Tyan.doPostEvent({
			event: 'GetStandardInspectionList',
			data: { id },
			onEnd: ({ errorMessage, initValues项目信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else if (initValues项目信息) {
					this.setState({ initValues项目信息 })
				}
			}
		})
	}

	handleGetStandardGuidelineList = (inspectionID) => {
		const { id } = this.state
		Tyan.doPostEvent({
			event: 'GetStandardInspectionList',
			data: { id },
			onEnd: ({ errorMessage, initValues项目信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else if (initValues项目信息) {
					this.setState({ initValues项目信息 })
				}
			}
		})
		Tyan.doPostEvent({
			event: 'GetStandardGuidelineList',
			data: { id, StandardInspectionID: inspectionID },
			onEnd: ({ errorMessage, initValues指标信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else if (initValues指标信息) {
					this.setState({ initValues指标信息 })
				}
			}
		})
	}

	bChanged = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		return hasChangedValues(this) && values.标准编号 !== ''
	}

	handleStandardInspectionSelect = selected => {
		const inspectionID = !selected || selected.length == 0 ? -1 : selected[0].data['id']
		this.setState({ GuidelineSelected: -1, InspectionSelected: inspectionID })
		this.handleGetStandardGuidelineList(inspectionID)
	}

	handleAddStandardInspection = () => {
		const { JudgeStandardID } = this.state
		var onlyView = !this.canEdit()
		Tyan.pubForm.showDialog('标准检测项目', props => <StandardInspectionDiv {...props} id={-1} JudgeStandardID={JudgeStandardID} onlyView={onlyView} onSave={this.handleGetStandardInspectionList} />)
	}

	handleEditStandardInspection = (inspectionID) => {
		const { JudgeStandardID, onlyView } = this.state
		var bOnlyView = !this.canEdit() || onlyView === true
		Tyan.pubForm.showDialog('标准检测项目', props => <StandardInspectionDiv {...props} id={inspectionID} JudgeStandardID={JudgeStandardID} onlyView={bOnlyView} onSave={this.handleGetStandardInspectionList} />)
	}

	handleAddStandardGuideline = (inspectionID) => {
		var onlyView = !this.canEdit()
		Tyan.pubForm.showDialog('标准检测指标', props => <StandardGuidelineDiv {...props} id={-1} StandardInspectionID={inspectionID} onlyView={onlyView} onSave={() => this.handleGetStandardGuidelineList(inspectionID)} />)
	}

	handleEditStandardGuideline = (guidelineID) => {
		const { InspectionSelected, onlyView } = this.state
		var bOnlyView = !this.canEdit() || onlyView === true
		Tyan.pubForm.showDialog('标准检测指标', props => <StandardGuidelineDiv {...props} id={guidelineID} onlyView={bOnlyView} onSave={() => this.handleGetStandardGuidelineList(InspectionSelected)} />)
	}

	canEdit = () => {
		const { initValues基本信息, applyType } = this.state
		const { 状态名称 } = initValues基本信息
		return 状态名称 === '新增修改' && applyType !== '价格变更'
	}

	fieldset基本信息 = () => {
		const { initValues基本信息, changedValues基本信息, applyType, onlyView } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		const { 状态名称 } = initValues基本信息

		const { optionsParas: { obj分类 }, } = this.state
		const { list: optionsList } = getListFromValues('分类', null, obj分类, {})

		let items = []
		items.push(
			{ _text: '委托单编号', name: '申请编号', minWidth: '45%', disabled: true },
			{ _text: '申请状态', name: '状态名称', minWidth: '45%', disabled: true },
			{ _text: '申请人', name: '创建人', minWidth: '45%', disabled: true },
			{ _date: '申请日期', name: '创建时间', minWidth: '45%', disabled: true },
			{ _text: '申请类型', minWidth: applyType !== '价格变更' ? '45%' : '90%', disabled: true },
			{
				_treeselect2: '所属分类', name: 'StandardItemID', displayField: '所属分类', options: optionsList,
				displayFull: '/', fullNameField: 'fullName', multiSelect: false, leafOnly: true, cdt: () => applyType !== '价格变更', required: true,
			},
			{ _text: '备注(方法或标准)', name: '备注', minWidth: '90%', maxRows: 3, required: true },
			{ _files: '附件', minWidth: '90%', },
		)
		if (applyType === '价格变更') {
			items.push(
				{ _select: '项目编号', name: '判定标准', minWidth: '90%', required: true, editable: true, forceSelection: false, onChange: (v) => this.handlerSelectJudgeStandard(v) },
				{ _float: '牌价（元）', name: '已有牌价', textAlign: 'left', minWidth: 状态名称 !== '申请中' ? '45%' : '90%', disabled: true },
				{ _float: '修改为', name: '牌价', textAlign: 'left', minWidth: '45%', required: 状态名称 == '金额录入', disabled: 状态名称 !== '金额录入' || onlyView === true, cdt: () => 状态名称 !== '申请中', },
			)
		}
		else if (applyType === '价格/项目变更') {
			items.push(
				{ _select: '项目编号', name: '判定标准', minWidth: '90%', required: true, editable: true, forceSelection: false, onChange: (v) => this.handlerSelectJudgeStandard(v) },
				{ _text: '项目名称', name: '标准名称', minWidth: '90%', required: true },
				{ _text: '繁体项目名称', name: '繁体标准名称', minWidth: '90%', required: true },
				{ _text: '英文项目名称', name: '英文标准名称', minWidth: '90%', required: true },
				{ _float: '牌价（元）', name: '已有牌价', textAlign: 'left', minWidth: 状态名称 !== '申请中' ? '45%' : '90%', disabled: true },
				{ _float: '修改为', name: '牌价', textAlign: 'left', minWidth: '45%', required: 状态名称 == '金额录入', disabled: 状态名称 !== '金额录入' || onlyView === true, cdt: () => 状态名称 !== '申请中', },
			)
		}
		else if (applyType === '项目变更') {
			items.push(
				{ _select: '项目编号', name: '判定标准', minWidth: '90%', required: true, editable: true, forceSelection: false, onChange: (v) => this.handlerSelectJudgeStandard(v) },
				{ _text: '项目名称', name: '标准名称', minWidth: '90%', required: true },
				{ _text: '繁体项目名称', name: '繁体标准名称', minWidth: '90%', required: true },
				{ _text: '英文项目名称', name: '英文标准名称', minWidth: '90%', required: true },
			)
		}
		else if (applyType === '新增项目') {
			items.push(
				// { _select: '项目编号', name: '判定标准', minWidth: '90%', editable: true, forceSelection: false, onChange: (v) => this.handlerSelectJudgeStandard(v) },
				{ _text: '项目名称', name: '标准名称', minWidth: '90%', required: true },
				{ _text: '繁体项目名称', name: '繁体标准名称', minWidth: '90%', required: true },
				{ _text: '英文项目名称', name: '英文标准名称', minWidth: '90%', required: true },
				{ _files: '项目测试表（工程专用）', name: '测试项目附表', minWidth: '90%', multiple: false },
				{ _float: '牌价（元）', name: '牌价', textAlign: 'left', minWidth: '90%', required: 状态名称 == '金额录入', disabled: 状态名称 !== '金额录入' || onlyView === true, cdt: () => 状态名称 !== '申请中', },
			)
		}
		return items
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset项目信息 = () => {
		const { id, copyID, onlyView } = this.state
		var bOnlyView = !this.canEdit() || onlyView === true
		const gridButtons = [
			{
				_button: '添加项目...', icon: 'plus',
				hidden: data => data.depth >= 1 || bOnlyView,
				handler: (data, record) => {
					this.handleAddStandardInspection()
				},
			},
			{
				_button: '添加指标...', icon: 'plus',
				hidden: data => id <= 0 || !data.类型 || bOnlyView,
				handler: (data, record) => {
					this.handleAddStandardGuideline(record.id || 0, 0)
				},
			},
			// {
			// 	_button: '粘贴副本...', icon: 'paste',
			// 	hidden: data => id <= 0 || !data.类型 || data.类型 == '项目组' || copyID <= 0,
			// 	handler: (data, record) => {
			// 		this.handleCopyStandardGuideline(record.id || 0, 0)

			// 	},
			// },
			{
				_button: '详情...', icon: 'info',
				hidden: data => data.depth == 0,
				handler: (data, record) => {
					this.handleEditStandardInspection(record.id)
				}
			},
		]

		return [
			{
				_treegrid: '', minRows: 3, minWidth: '200', height: '100%',
				root: { visible: true, text: '全部', icon: 'sitemap' },
				trees: [
					{
						name: '项目', treeField: '名称', groupID: 'FatherID', sort: 'SortNum',
						icon: data => data.类型 == '项目' ? 'flask' : data.下级项目数 > 0 ? 'folder' : 'folder-o',
					},
					{
						name: '指标组', treeField: '名称', parentID: 'StandardInspectionID', sort: 'SortNum',
						icon: 'cube',
					}
				],
				contextmenu: [...gridButtons],
				columns: [
					{ _tree: '名称', minWidth: 300, menuDisabled: true, flex: 1, sortable: false, hideable: false },
					{ _text: '', name: '指标数', width: 60, menuDisabled: true, sortable: false, hideable: false, },
				],
				onSelect: this.handleStandardInspectionSelect
			}
		]
	}

	fieldset指标信息 = () => {
		return [{
			_grid: '', name: '指标', rowNumbers: true, minRows: 5, height: '100%',
			columns: [
				{ _text: '指标名称', minWidth: 400, flex: 1 },
				// { _richtext: '标准值', minWidth: 400, flex: 1 },
				// {
				// 	_buttons: [
				// 		{ _button: `生成副本`, handler: (data, record) => { this.setState({ copyID: record.id }); Ext.toast('复制成功'); } }
				// 	], width: '101px', margin: 0, align: 'right'
				// },
			],
			onDoubleTap: (data) => {
				this.handleEditStandardGuideline(data.id)
			},
		}]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { initValues基本信息, processing, id, applyType, onlyView } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 状态名称, 提交时间 } = initValues基本信息
		let fieldsets = []
		if (状态名称 !== '申请中' && 状态名称 !== '金额录入' && 状态名称 !== '项目初审' && applyType !== '价格变更') {
			fieldsets.push(
				{
					_fieldsets: [
						{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
						{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
					], docked: 'right', disabled: true, fullblock: true, heigth: '65%', width: '35%'
				},
				// { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), docked: 'right', disabled: true, fullblock: true, heigth: '65%', width: '35%' },
				{ title: '项目新增/修改申请', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: 状态名称 !== '申请中' || onlyView === true, docked: 'top' },
				{ title: '', name: '项目信息', _fieldset: this.fieldset项目信息(), docked: 'left', minWidth: '450px', fullblock: true, cdt: () => 状态名称 !== '申请中' && 状态名称 !== '金额录入' && 状态名称 !== '项目初审' && applyType !== '价格变更' },
				{ title: '', name: '指标信息', _fieldset: this.fieldset指标信息(), fullblock: true, cdt: () => 状态名称 !== '申请中' && 状态名称 !== '金额录入' && 状态名称 !== '项目初审' && applyType !== '价格变更' },
			)
		}
		else {
			fieldsets.push(
				{
					_fieldsets: [
						{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
						{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
					], docked: 'right', disabled: true, fullblock: true, heigth: '65%', width: '35%'
				},
				// { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), docked: 'right', disabled: true, fullblock: true, width: '35%' },
				{ title: '项目新增/修改申请', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: 状态名称 !== '申请中' || onlyView === true, fullblock: true },
			)
		}
		return <Body data={this} minWidth="900"
			controls={
				[
					{ _flow: 'JudgeStandardApplyFlow', disabled: this.bChanged() || processing, cdt: () => id > 0 && onlyView === false, id: this.state.id },
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged(), cdt: () => (状态名称 === '申请中' || 状态名称 === '金额录入' || 状态名称 === '金额批准' || 状态名称 === '新增修改') && onlyView === false },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && 状态名称 === '申请中' && 提交时间 == nullDate && onlyView === false, handler: this.handlerDelete, disabled: this.bChanged() },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={fieldsets}
		/>
	}
}

export default connect()(JudgeStandardApplyDetail)